// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"5301ba41","157":"49225cb3","311":"13f7882d","343":"219c83fd","484":"1f23d761","525":"81b6a87f","633":"6c471624","651":"bc46845d","815":"6a608e4d","859":"282c83af","911":"dbbeacf0","942":"877efaa8","952":"d9b8e852","964":"ece4475f"}[chunkId] + ".chunk.js";
};